import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

import { useIsClientSide } from "@/utils/hooks/isClient.hook";

type CashbackContextValue = {
    cashbackAmount: number | null;
    cashbackUnit: string | null;
    priceAfterCashbackIsApplied: number | null;
    redirectPath?: string;
};

export type CashbackContextProviderProps = {
    cashbackAmount: number | null;
    cashbackUnit: string | null;
    priceAfterCashbackIsApplied: number | null;
};

export const CashbackContext = createContext<CashbackContextValue | undefined>(
    undefined
);
CashbackContext.displayName = "CashbackContext";

const CASHBACK_SELECTOR = "#cashback";

export const CashbackContextProvider = ({
    children,
    cashbackAmount,
    cashbackUnit,
    priceAfterCashbackIsApplied
}: RequireChildrenFor<CashbackContextProviderProps>) => {
    const isClientSide = useIsClientSide();

    const redirectPath = isClientSide
        ? document.querySelector<HTMLDivElement>(CASHBACK_SELECTOR)?.dataset
              .redirectPath
        : undefined;

    return (
        <CashbackContext
            value={{
                cashbackAmount: cashbackAmount,
                cashbackUnit: cashbackUnit,
                priceAfterCashbackIsApplied: priceAfterCashbackIsApplied,
                redirectPath: redirectPath
            }}
        >
            {children}
        </CashbackContext>
    );
};

export const useCashbackContext = (): CashbackContextValue => {
    const context = use<CashbackContextValue | undefined>(CashbackContext);

    if (!isDefined(context)) {
        throw new Error(`${CashbackContext.displayName} is undefined.`);
    }

    return context;
};
